<template>
    <div class="scroll-table" :class="{ 'not-border-bottom': notBorderBottom, 'border-top': borderTop }">
        <table :class="{ [customClass]: true, 'header-dark': darkHeader }">
            <thead>
                <slot name="head"></slot>
            </thead>
            <tbody>
                <slot name="body"></slot>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "TableBlock",
    props: {
        customClass: {
            typeof: String,
            default: ''
        },
        darkHeader: {
            typeof: Boolean,
            default: false
        },
        notBorderBottom: {
            typeof: Boolean,
            default: false
        },
        borderTop: {
            typeof: Boolean,
            default: false
        }
    }
}
</script>
<style scoped lang="scss">
.scroll-table {
    overflow-x: auto;
    transform: rotateX(180deg);
    -ms-transform: rotateX(180deg);
    -webkit-transform: rotateX(180deg);
    scrollbar-width: thin;
    scrollbar-color: #E0E0E0 #fff;
    border-bottom: 1px solid #E0E0E0;

    &.not-border-bottom {
        border-bottom: 0
    }
    &.border-top {
        border-top: 1px solid #E0E0E0;
    }

    &.border-top {
        border-top: 1px solid #E0E0E0;
    }

    &::-webkit-scrollbar {
        height: 12px;
        background: #E0E0E0;
    }

    &::-webkit-scrollbar-track {
        background: #fff;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #E0E0E0;
        border-radius: 8px;
        border: 2px solid #fff;
    }

    table {
        border-collapse: collapse;
        transform: rotateX(180deg);
        -ms-transform: rotateX(180deg);
        -webkit-transform: rotateX(180deg);
        min-width: 100%;

        &.header-dark {
            th {
                background: #F1F1F1 !important;
            }
        }

        &#table-3 {
            min-width: 100%;

            .td-check {
                div {
                    display: flex;
                    align-items: center;

                    svg {
                        margin-right: 10px;
                    }
                }
            }

            .td-client {
                div {
                    white-space: nowrap;
                    display: flex;
                    align-items: center;

                    .ava {
                        width: 24px;
                        min-width: 24px;
                        max-width: 24px;
                        height: 24px;
                        min-height: 24px;
                        max-height: 24px;
                        border-radius: 50%;
                        overflow: hidden;
                        margin-right: 8px;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }
                }
            }
        }

        th {
            vertical-align: top;
        }

        th,
        td {
            background: #fff;
            padding: 10px 12px;
            text-align: left;
            font-family: 'Circe';
            font-style: normal;
            font-weight: 400;
            font-size: 13px;
            line-height: 16px;
            color: #000000;
            border: 1px solid #E0E0E0 !important;

            &.font-bold {
                font-weight: bold;
            }

            &.no-wrap {
                white-space: nowrap;
            }

            &:first-child {
                border-left: 0 !important;
            }

            &:last-child {
                border-right: 0 !important;
            }

            .open-hide {
                border: 1px solid #1A1A1A;
                width: 12px;
                height: 12px;
                display: flex;
                justify-content: center;
                border-radius: 2px;

                &::after {
                    content: "+";
                    line-height: 12px;
                }

                &.open {
                    align-items: center;

                    &::after {
                        content: "";
                        display: block;
                        height: 1px;
                        background: #1A1A1A;
                        width: 6px;
                        border-radius: 1px;
                        line-height: 10px;
                    }
                }
            }
        }

        tbody {
            tr {
                &.parrent {
                    td {
                        background: #F1F1F1;
                    }
                }

                &:last-child {
                    td {
                        border-bottom: 0 !important;
                    }
                }
            }
        }
    }
}
</style>